<div class="jplus-confirm-dialog">
  <mat-dialog-content>
    <div>
      @if (data?.title) {
        <h5>{{ data?.title || 'Are you sure you want to proceed?' }}</h5>
      }
      @if (data?.description) {
        <p>{{ data?.description }}</p>
      }
      @if(!data?.title && !data?.description) {
        <p>Are you sure you want to proceed?</p>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions [align]="'end'">
    <button mat-button (click)="actionInput(false)">Cancel</button>
    <button mat-flat-button color="primary" cdkFocusInitial (click)="actionInput(true)">
      {{ data?.confirmButtonText || 'Proceed' }}
    </button>
  </mat-dialog-actions>
</div>
